/**
 * @module SharedModule
 * @description
 * This is the shared module of the application.
 * It contain the application related dependencies that can be shared across the applications
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhoneNumberValidationDirective } from '@app/core/helpers/directives/phonenumber.directives';
import { AppPasswordDirective } from '@app/core/helpers/directives/phonenumber-show-hide.directives';
import { PipeModule } from '@app/core/pipes/pipe.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';
import { ColorPickerModule } from 'ngx-color-picker';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';

@NgModule({
  declarations: [
    PhoneNumberValidationDirective,
    AppPasswordDirective
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PipeModule,
    FormsModule
  ],
  exports: [
    PhoneNumberValidationDirective,
    AppPasswordDirective,
    CommonModule,
    TextMaskModule,
    NgxMaterialTimepickerModule,
    PipeModule,
    FormsModule,
    ReactiveFormsModule,
    ColorPickerModule,
  ]
})
export class SharedModule {
}
